import http from "@/http-common";

const getAll = async (orgId, partyId) => {
  return await http
    .get(`/admin/organization/${orgId}/party/${partyId}/whatsapp/group`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const create = async (orgId, partyId, options) => {
  return await http
    .post(`/admin/organization/${orgId}/party/${partyId}/whatsapp/group`, options)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (orgId, partyId, id, options) => {
  return await http
    .put(`/admin/organization/${orgId}/party/${partyId}/whatsapp/group/${id}`, options)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  create,
  getAll,
  update,
};
